const SUPPORTED = /\.(mp3|m4a)$/i
const MAX_FILES = 50

export const splitBulkUploadPick = (files) => {
  if (files.length > MAX_FILES) {
    return { good: [], message: `Please pick ${MAX_FILES} files or fewer (you picked ${files.length}).` }
  }
  const good = files.filter((f) => SUPPORTED.test(f.name))
  const bad = files.filter((f) => !SUPPORTED.test(f.name))
  return {
    good,
    message: bad.length ? `Skipped (only mp3 and m4a are supported): ${bad.map((f) => f.name).join(', ')}` : null
  }
}

export const bulkUploadContentType = (file) => {
  if (/\.m4a$/i.test(file.name)) return 'audio/mp4'
  if (/\.mp3$/i.test(file.name)) return 'audio/mpeg'
  return file.type || 'application/octet-stream'
}
